import {Enums} from '../Config/Config';
import {EventBus} from '../EventBus';

const MapStore = {
    state: () => ({
        activeStateFips: '36',
        activeDistrictType: Enums.LEG_BODY.CONGRESS,
        activeDistrictFIPS: '0',
        hoverDisplayData:[],  
        selectedData:{},
        opacitySliderValue:1,//Move along with addresses to external components store?
        mapBounds:[],
        mapColumn: Enums.MAP_VARIABLES.DEVIATION,
        marker: null,
        map: null,
        markerLoc:[],
        tractsLoading: false,
        geoTypeVisible: 'jurisdiction'
    }),
    mutations: {
        setMap(state,val){
            state.map = val;
        },
        setgeoTypeVisible(state,obj){
            let isVap = obj.isVap;
            let val = obj.val;
            if(typeof isVap === 'undefined') isVap = false;
            //console.log(isVap)
            state.geoTypeVisible = val;
            
            if(val==='tracts' && !isVap){
                EventBus.updateQueryObj(['tractLayer','true']);
                //EventBus.updateQueryObj(['tractVAPLayer', -1]);
            }else{
                EventBus.updateQueryObj(['tractLayer',-1]);
            }

            if(val!=='tracts'){
                EventBus.updateQueryObj(['tractLayer',-1]);
            }

            if(val==='voting-precincts'){
                EventBus.updateQueryObj(['voterLayer','true']);
            }else{
                EventBus.updateQueryObj(['voterLayer',-1]);
            }
        },
        setTractsLoading(state, val){
            state.tractsLoading = val;
        },
        setOpacitySlideValue(state,val){
            state.opacitySliderValue = val;
        },
        setMapBounds(state,val){
            state.mapBounds = val;
        },
        setStateFips(state, val){
            state.activeStateFips = val;
        },
        setDistrictType(state,val){
            state.activeDistrictType = val;
            EventBus.updateQueryObj(['districtType',val.toString()]);
        },
        setDistrictFIPS(state,val){
            state.activeDistrictFIPS = val.toString();
        },
        setHoverDisplayData(state,val){
            state.hoverDisplayData = val;
        },
        setSelectedData(state,val){
            if(val.dataSource){
                state.selectedData = {...state.selectedData}
                state.selectedData[val.dataSource] = val;
                if(val.geoid){
                    EventBus.updateQueryObj(['geoid',val.geoid.toString()]);
                }else{
                    EventBus.updateQueryObj(['geoid','-1']);
                }
            }else{
                EventBus.updateQueryObj(['geoid','-1']);
                state.selectedData = {};
            }

        },
        setMapColumn(state, val){
            state.mapColumn = val;
            EventBus.updateQueryObj(['mapData',val.toString()])
        },
        setMarkerLoc(state,val){
            if(val){
                state.markerLoc = val.split(',')
                if(+state.markerLoc[0]===-1){
                    EventBus.updateQueryObj(['markerL',"-1"]);
                    return
                }
                state.markerLoc[0] = (+state.markerLoc[0]).toFixed(4);
                state.markerLoc[1] = (+state.markerLoc[1]).toFixed(4);

                EventBus.updateQueryObj(['markerL', state.markerLoc]);
            }else{
                EventBus.updateQueryObj(['markerL',"-1"]);
            }
            
        }
    },
    actions: { },
    getters: {
        getMap(state){
            return state.map;
        },
        getMapZoom(state){
            if(!state.map) return 0;
            return state.map.getZoom();
        },
        getgeoTypeVisible(state){
            return state.geoTypeVisible;
        },
        getMarkerLoc(state){
            return state.markerLoc;
        },
        getMapColumn(state){
            return state.mapColumn;
        },
        getOpacitySlideValue(state){
            return state.opacitySliderValue;
        },
        getMapBounds(state){
            return state.mapBounds;
        },
        getMapBoundsString(state){
            return`${state.mapBounds._ne.lng},${state.mapBounds._ne.lat},${state.mapBounds._sw.lng},${state.mapBounds._sw.lat}`;
        },
        getStateFips:function(state){
            return state.activeStateFips;
        },
        getDistrictType:function(state){
            return state.activeDistrictType;
        },
        getDistrictFIPS:function(state){
            return state.activeDistrictFIPS;
        },
        getDistrictNumber:function(state){
            return state.activeDistrictFIPS.substring(2,state.activeDistrictFIPS.length-1);
        },
        getHoverDisplayData:function(state){
            return state.hoverDisplayData;
        },
        getSelectedData:function(state){
            return state.selectedData;
        },
        getMarker: function(state){
            return state.marker;
        },
        getTractsLoading: function(state){
            return state.tractsLoading;
        }
    }
  } 

export default MapStore;